export enum DataSetSettingEnum {
    A1 = 1, 
    A2 = 2,
    A1A2 = 3
}